import React, { Component } from 'react'
import { Menu, Header, Popup, Icon, Button } from 'semantic-ui-react'
import { saveCensusWarning } from '../api/setFormData'
import { ShortButton } from "kx-common-components";
import { confirmAlert } from "react-confirm-alert";
export default class CensusPopup extends Component {
  constructor() {
    super()
    this.state = {
      highlightMe: ""
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.warningValue !== this.props.warningValue) {
      let newField = {
        id: this.props.field.id,
        valueChanged: 1,
        merchandiseId: this.props.field.merchandiseId
      }
      saveCensusWarning(newField)
      this.props.updateFieldValidationObject(
        Object.assign({}, this.props.field, {
          valueChanged: 1,
          overrideCodeUsed: ''
        })
      )
    }
  }

  handleItemClick = overrideCode => {
    let newField = {
      id: this.props.field.id,
      overrideCodeUsed: overrideCode.overrideCode,
      merchandiseId: this.props.field.merchandiseId
    }
    console.log("newField", newField)
    console.log("overrideCode", overrideCode)

    this.handleClose()
    saveCensusWarning(newField)
    this.props.updateFieldValidationObject(Object.assign({}, this.props.field, {
      overrideCodeUsed: overrideCode.overrideCode,
      valueChanged: 2
    }))
  }

  handleClose = () => {
    this.setState({ isOpen: false })
  }
  handleOpen = () => {
    this.setState({ isOpen: true })
  }
  render() {
    const { warningDetails, field } = this.props
    const triggerText =
      field.valueChanged === 1 ? (
        <span>
          <Icon name='check circle' />
          FIELD VALUE UPDATED ({warningDetails.fieldName})
          {/* <Icon name='external alternate' style={{ marginLeft: '8px' }} /> */}
        </span>
      ) : field.isWarningResolved === 1 ? (
        <span>
          <Icon name='check circle' />
          CORRECT AS ENTERED ({warningDetails.fieldName})
          {/* <Icon name='external alternate' style={{ marginLeft: '8px' }} /> */}
        </span>
      ) : field.overrideCodeUsed ? (
        <span>
          CENSUS WARNING OVERRIDE CODE USED ({warningDetails.fieldName}): 
          <b>
            {field.overrideCodeUsed}&nbsp;-&nbsp;
            {(warningDetails.overrideCodes||[]).find(a=>a.overrideCode==field.overrideCodeUsed)?.description || "UNKNOWN"}
          </b>
          {/* <Icon name='external alternate' style={{ marginLeft: '8px' }} /> */}
        </span>
      ) : (
        <span>
          <Icon name='warning sign' />
          {warningDetails.narativeText + " ("+warningDetails.fieldName+")"}
          {/* <Icon name='external alternate' style={{ marginLeft: '8px' }} /> */}
        </span>
      )
       const triggerClassName = (field.valueChanged === 1 ? 
                                'warning-pending' : 
                                (field.isWarningResolved === 1 ? 
                                  'warning-resolved' : 
                                  (field.overrideCodeUsed ? 'warning-pending' : 'warning-text')))
                                  //console.log("triggerClassName", triggerClassName, field)
    
      const titleText = `${ this.props.code + " - " } ${triggerText} ${"#Invoice 00"+(this.props.invoiceIndex+1)+" #Line 00"+(this.props.lineItemIndex+1)}
      ${this.props.dutyItemIndex!=null ? " #Duty 00"+(this.props.dutyItemIndex+1): ''}`;                            
      return (
      <><div className={`${this.state.highlightMe}`} style={{"padding":"4px", "display":"flex"}}>
      <span 
        title={"#Invoice 00"+(this.props.invoiceIndex+1)+" #Line 00"+(this.props.lineItemIndex+1)} 
        className={`${triggerClassName}`} 
        style={{
                  "fontSize":"10px", 
                  "textOverflow":"ellipsis", 
                  "width":"68%"
              }}
        >
          { this.props.code + " - " }
          { triggerText } {"#Invoice 00"+(this.props.invoiceIndex+1)+" #Line 00"+(this.props.lineItemIndex+1)}
          { this.props.dutyItemIndex!=null ? " #Duty 00"+(this.props.dutyItemIndex+1): ''}
      </span>
      <span 
        className={"censusBoxContainer"}
        
        onMouseOver={()=>{
          this.setState({"highlightMe": "highlightMe"})
        }} 
        onMouseOut={()=>{
          this.setState({"highlightMe": ""})
        }}
      >
      <span style={{"marginRight":"4px"}}>
      {
        this.props.field.valueChanged !== 1 && 
       <span> <ShortButton 
       style={{fontSize: "10px"}} onClick={()=>{
        this.handleClose()
        setTimeout(()=>{
          confirmAlert({
          title: "Confirmation!",
          message: "Please change the field ["+this.props.field.fieldId+"] value for this census warning if you don't intend to send an override code",
          buttons: [
            {
              label: "OK",
              onClick: () => {
                let newField = {
                  id: this.props.field.id,
                  valueChanged: 1,
                  merchandiseId: this.props.field.merchandiseId
                }
                saveCensusWarning(newField)
                this.props.updateFieldValidationObject(
                  Object.assign({}, this.props.field, {
                    valueChanged: 1,
                    overrideCodeUsed: ''
                  })
                )
              },
            },
            {
              label: "Cancel",
              onClick: () => {}
            }
          ],
        });
         },0)
      }}
      >VALUE UPDATED</ShortButton></span>
      }</span>  
      <Popup
        className='census-popup'
        position='bottom right'
        trigger={
          <span><ShortButton style={{fontSize: "10px", "float":"right"}} onClick={()=>{
            this.handleOpen()
          }}>OVERRIDE</ShortButton> 
          </span> 
        }
        on='click'
        style={{"display": "block"}}
        open={this.state.isOpen}
        onClose={this.handleClose}
        onOpen={this.handleOpen}
      >
        <Popup.Header className='warning-header'>
          <Icon name='warning sign' />
          Census Warning
        </Popup.Header>
        <Popup.Content>
          <div>
            <div className='header-text'>
              <Header>
                {warningDetails.code} {warningDetails.narativeText}
              </Header>
                    {warningDetails.description.length > 30 ?
                      <a
                        style={{ color: this.state.showDetails?'':'blue', cursor: 'pointer' }}
                        onClick={() => { this.setState({ showDetails: !this.state.showDetails }) }}>

                        {this.state.showDetails ?
                          warningDetails.description :
                          (warningDetails.description + "").substring(0, 28) + "..."
                        }
                      </a> :
                      warningDetails.description
                    }
            </div>
            <Menu icon vertical>
              {(warningDetails.overrideCodes || []).sort((a,b)=>{
                if(a.overrideCode=='50')return -1;
                if(b.overrideCode=='50')return 1;
                return parseInt(a.overrideCode) - parseInt(b.overrideCode);
                }).map((overrideCode, index) => ( 
                <Menu.Item
                  key={index}
                  name={overrideCode.overrideCode}
                  active={overrideCode.overrideCode === field.overrideCodeUsed}
                  onClick={() => this.handleItemClick(overrideCode)}
                  className={'overridecode-list-item'}
                >
                  <Header as='h5' className='overridecode-header'>
                    {`${overrideCode.overrideCode}. ${
                      overrideCode.description
                    }`}{' '}
                    {overrideCode.overrideCode === field.overrideCodeUsed && (
                      <Icon
                        style={{ color: '#28B463', fontSize: '14px' }}
                        name='check circle'
                      />
                    )}
                  </Header>
                  <p className='overridecode-description'>
                    {overrideCode.detailedDescription}
                  </p>
                </Menu.Item>
              ))}
            </Menu>
          </div>
        </Popup.Content>
      </Popup>
      
      </span>
      </div></>
    )
  }
}
